/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-12 09:32:01
 * @LastEditTime: 2025-03-06 09:57:22
 */
//ajax封装
import axios from 'axios';
import qs from 'qs';
import { getLanguage } from '@/utils/utils';
const language = getLanguage();

const base = '';
// 请求前拦截
axios.interceptors.request.use(
  config => {
    config.headers['Origin-Language'] = language;
    return config;
  },
  err => {
    console.log('请求超时');
    return Promise.reject(err);
  }
);

// 返回后拦截
axios.interceptors.response.use(
  data => {
    // 拦截ide接口，判断是否登录，没登陆跳转至登录页面
    if (data.config.url.indexOf('/api/cloudide') > -1) {
      if (data.data && data.data.code === 401){
        // const queryParams:any = new URLSearchParams(window.location.search);
        // const toUrl = queryParams?.size > 0 ? `${window.location.pathname}?${queryParams.toString()}` : `${window.location.pathname}`
        const toUrl = window.location.href;
        window.location.href = `${process.env.REACT_APP_LOGIN_URL}zh/l/login?forward=${toUrl}`;
        return;
      }
    }
    return data;
  },
  err => {
    console.log('err', err)
    if (err.response.status === 504 || err.response.status === 404) {
      console.log('服务器连接异常');
      // console.log("服务器被吃了⊙﹏⊙∥");
    } else if (err.response.status === 401) {
      console.log('登录信息失效：'+401);
      // 401 的时候需要返回信息，因为需要通过 该 信息判断是否跳转至登录页面
      return Promise.resolve(err.response);
      // console.log("登录信息失效⊙﹏⊙∥");
    } else if (err.response.status === 500) {
      console.log('服务器连接异常：'+500);
    }
    // message.error('服务器请求失败：'+err.response.status);
    return Promise.reject(err);
  }
);

const Http = {
  post: (api,data) =>{
    return new Promise((resolve, reject)=>{
      axios.post(`${base}/`+api,qs.stringify(data),{
        headers: {'Origin-Language': language }
      }).then((res)=>{
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    });
      
  },
  get: (api,data) => {
    return new Promise((resolve)=>{
      axios.get(`${base}/`+api,qs.stringify(data), {
        headers: {'Origin-Language': language }
      }).then((res)=>{
        resolve(res);
      });
    });
  },
  
  jsonPost: (api, data, headerConfig = {}) => {
    return new Promise((resolve, reject) => {
      axios.post(`${base}/${api}`, data, {
        headers: {
          ...headerConfig,
          'Content-Type': 'application/json;charset=utf-8',
          'Origin-Language': language
        }
      }).then(res => {
        resolve(res);
      }).catch(error => {
        reject(error);
      });
    });
  }
};

export default Http;
